import { render, staticRenderFns } from "./TestDetails.vue?vue&type=template&id=4c42b598&scoped=true"
import script from "./TestDetails.vue?vue&type=script&lang=js"
export * from "./TestDetails.vue?vue&type=script&lang=js"
import style0 from "./TestDetails.vue?vue&type=style&index=0&id=4c42b598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c42b598",
  null
  
)

export default component.exports